import { render, staticRenderFns } from "./TablePatient.vue?vue&type=template&id=1cd67a01"
import script from "./TablePatient.vue?vue&type=script&lang=js"
export * from "./TablePatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports